document.addEventListener('DOMContentLoaded', () => {
  const openBtn = document.getElementById('open-samples');
  const modal = document.getElementById('samples-modal');
  const form = document.getElementById('samples-form');
  const cancel = document.getElementById('samples-cancel');
  const error = document.getElementById('samples-error');
  const countEl = document.getElementById('samples-count');

  if (!openBtn || !modal || !form) return;

  const MAX = 5;

  function updateCount() {
    const checked = form.querySelectorAll('.sample-toggle:checked').length;
    countEl.textContent = `${checked} / ${MAX} selected`;
  }

  openBtn.addEventListener('click', () => {
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    updateCount();
  });

  cancel.addEventListener('click', () => {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
  });

  form.addEventListener('change', (e) => {
    if (!e.target.classList.contains('sample-toggle')) return;
    const checked = form.querySelectorAll('.sample-toggle:checked');
    if (checked.length > MAX) {
      e.target.checked = false; // revert
    }
    updateCount();
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    error.hidden = true;

    const picks = Array.from(form.querySelectorAll('.sample-toggle:checked'))
      .slice(0, MAX)
      .map(input => ({
        id: Number(input.dataset.variantId),
        quantity: 1,
        properties: { '_sample': 'true' } // helpful for fulfilment
      }));

    if (!picks.length) {
      error.hidden = false;
      return;
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: picks })
      });

 if (res.ok) {
        // Close the modal
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');

        // Trigger Horizon cart drawer
        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                data: {
                  itemCount: cart.item_count,
                  source: 'product-form-component'
                }
              }
            }));
            const cartDrawer = document.querySelector('cart-drawer-component');
            if (cartDrawer) cartDrawer.open();
          });

        return;
      }

      if (!res.ok) throw new Error('Add to cart failed');

    } catch (err) {
      error.textContent = 'Sorry, something went wrong adding your samples. Please try again.';
      error.hidden = false;
    }
  });
});